import gql from 'graphql-tag'

const appuntamentiPerStato = gql`
  query azioni (
    $limit: Int!,
    $stato: StatoAppuntamento,
    $dataDa: DateTime,
    $dataA: DateTime,
  ) {
    azioni (
      limit: $limit,
      offset: 0,
      where: { OR: [
        {
          tipoAzioneId: 1,
          appuntamentoStato: $stato,
          dataOra_gte: $dataDa,
          dataOra_lte: $dataA
        }
      ]},
      orderBy: appuntamentoADataOra_ASC
    ) {
      totalCount
      nodes {
        id
        utenteId
        utente {
          id
          nome
        }
        clienteId
        cliente {
          id
          nome
          email
          telefono
        }
        offertaId
        offerta {
          id
          nome
        }
        campagnaId
        campagna {
          id
          nome
        }
        tipoAzioneId
        tipoAzione {
          id
          tipo
        }
        appuntamentoAgenteId
        appuntamentoAgente {
          id
          nome
        }
        dataOra
        descrizione
        appuntamentoDaDataOra
        appuntamentoADataOra
        appuntamentoLuogo
        appuntamentoStato
        appuntamentoOrigine
        promemoriaUtenteId
        promemoriaUtente {
          id
          nome
          ruolo
        }
        promemoriaDataOra
        promemoriaDismesso
        votoAgente
        flagSondaggioInviato
      }
    }
  }
`

export default appuntamentiPerStato



// WEBPACK FOOTER //
// ./src/graphql/queries/appuntamentiPerStato.js